"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M7.8 7.2a.6.6 0 00-.6.6v3.12a.6.6 0 00.6.6h3.12a.6.6 0 00.6-.6V7.8a.6.6 0 00-.6-.6H7.8zM13.08 7.2a.6.6 0 00-.6.6v3.12a.6.6 0 00.6.6h3.12a.6.6 0 00.6-.6V7.8a.6.6 0 00-.6-.6h-3.12zM7.2 13.08a.6.6 0 01.6-.6h3.12a.6.6 0 01.6.6v3.12a.6.6 0 01-.6.6H7.8a.6.6 0 01-.6-.6v-3.12zM13.08 12.48a.6.6 0 00-.6.6v3.12a.6.6 0 00.6.6h3.12a.6.6 0 00.6-.6v-3.12a.6.6 0 00-.6-.6h-3.12z" }), "Library");
//# sourceMappingURL=Library.js.map